import { useTranslation } from "react-i18next";
import InvestmentB from '@/assets/images/pillar-investmentB.jpg'
import KenyaImg from '@/assets/images/pillar-kenya.jpg'
import RwandaImg from '@/assets/images/pillar-rwanda.jpg'
import TanzanieImg from '@/assets/images/pillar-tanzania.jpg'
import EthiopieImg from '@/assets/images/pillar-ethiopia.jpg'
import CongoImg from '@/assets/images/pillar-congo.jpg'
import BurundiImg from '@/assets/images/pillar-burundi.jpg'

export default function BusinessHero() {
  const { t } = useTranslation();

  return (
    <section id="page-hero" data-dark-section className="relative min-h-screen flex items-center overflow-hidden bg-[#0A1628]">
      <div className="absolute inset-0">
        <img
          src={InvestmentB}
          alt="Business in East Africa"
          className="w-full h-full object-cover object-top opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628]/90 via-[#0A1628]/70 to-[#0A1628]/30" />
      </div>

      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/3 right-1/4 w-96 h-96 rounded-full bg-[#0A1628]/8 blur-3xl" />
        <div className="absolute bottom-1/4 left-1/3 w-64 h-64 rounded-full bg-[#0A1628]/5 blur-2xl" />
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-40 bg-[#0A1628] rounded-r-full" />
        <div className="absolute right-0 top-1/3 w-0.5 h-24 bg-[#0A1628]/30 rounded-l-full" />
      </div>

      <div className="relative z-10 w-full px-6 lg:px-12 pt-32 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-[calc(100vh-120px)]">
          <div className="flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 bg-[#0A1628]/15 border border-[#0A1628]/30 text-[#00C2C2] text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6 w-fit">
              <span className="block w-1.5 h-1.5 rounded-full bg-[#0A1628] animate-pulse" />
              {t("bizHeroTag")}
            </div>

            <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-[1.1] mb-6">
              {t("bizHeroTitle1")}<br />
              <span className="text-[#00C2C2]" style={{ fontStyle: "italic", fontWeight: 400 }}>
                {t("bizHeroTitle2")}
              </span>
            </h1>

            <p className="text-white/60 text-lg leading-relaxed max-w-xl mb-8">
              {t("bizHeroDesc")}
            </p>

            <div className="flex flex-wrap gap-3 mb-12">
              <a
                href="#registration"
                className="bg-[#0A1628] text-white text-sm font-bold px-7 py-3.5 rounded-full hover:bg-[#0A1628] transition-all whitespace-nowrap cursor-pointer"
              >
                {t("bizCtaRegister")}
              </a>
              <a
                href="#opportunities"
                className="bg-white/10 border border-white/25 text-white text-sm font-semibold px-7 py-3.5 rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                {t("bizCtaExplore")}
              </a>
            </div>

            <div className="flex flex-wrap gap-6 pt-8 border-t border-white/10">
              {[
                { value: "200+", label: t("bizStat1") },
                { value: "7", label: t("bizStat2") },
                { value: "7", label: t("bizStat3") },
                { value: "98%", label: t("bizStat4") },
              ].map((s) => (
                <div key={s.label}>
                  <div className="text-2xl font-bold text-white">{s.value}</div>
                  <div className="text-white/40 text-xs mt-0.5 tracking-wide">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex flex-col gap-4 items-end">
            <div className="bg-white/5 border border-white/12 rounded-2xl p-6 w-full max-w-sm backdrop-blur-sm">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#0A1628]/20 rounded-xl">
                  <i className="ri-building-2-line text-xl text-[#00C2C2]" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm">{t("bizCardTitle")}</p>
                  <p className="text-white/40 text-xs">{t("bizCardSubtitle")}</p>
                </div>
              </div>
              <div className="space-y-2">
                {[t("bizCard1"), t("bizCard2"), t("bizCard3"), t("bizCard4")].map((item) => (
                  <div key={item} className="flex items-center gap-2 text-white/60 text-xs">
                    <i className="ri-check-line text-[#00C2C2] text-sm shrink-0" />
                    {item}
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#0A1628]/10 border border-[#0A1628]/25 rounded-2xl p-5 w-full max-w-sm backdrop-blur-sm">
              <p className="text-[#00C2C2] text-xs font-semibold uppercase tracking-widest mb-3">{t("bizOppTitle")}</p>
              <p className="text-white font-bold text-base mb-1">{t("bizOppName")}</p>
              <div className="flex gap-2 flex-wrap mt-2">
                <span className="text-xs bg-white/10 text-white/70 px-2.5 py-1 rounded-full">Rwanda</span>
                <span className="text-xs bg-white/10 text-white/70 px-2.5 py-1 rounded-full">Health</span>
                <span className="text-xs bg-white/10 text-white/70 px-2.5 py-1 rounded-full">$500K–$2M</span>
              </div>
              <div className="mt-3 flex items-center gap-2 text-[#00C2C2] text-xs font-semibold cursor-pointer hover:underline">
                {t("details")} <i className="ri-arrow-right-line" />
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 w-full max-w-sm backdrop-blur-sm">
              <p className="text-white/50 text-xs uppercase tracking-widest mb-3">{t("bizCountriesTitle")}</p>
              <div className="grid grid-cols-4 gap-2">
                {[
                  { name: "Rwanda", img: RwandaImg },
                  { name: "Kenya", img: KenyaImg },
                  { name: "Tanzania", img: TanzanieImg },
                  { name: "Ethiopia", img: EthiopieImg },
                  { name: "Burundi", img: BurundiImg },
                  { name: "DRC", img: CongoImg },
                ].map((c) => (
                  <div key={c.name} className="relative overflow-hidden rounded-lg">
                    <div className="w-full h-14">
                      <img src={c.img} alt={c.name} loading="lazy" className="w-full h-full object-cover object-top" />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/70 to-transparent flex items-end px-1.5 pb-1">
                      <span className="text-white text-[10px] font-semibold">{c.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}